import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { createAsyncThunk } from '@reduxjs/toolkit';
import { isPlainObject } from '@beef/utils';
import { checkHouseConnection } from "../../../../../services/checkHouseConnection";
import { setIsCtnError } from "../../../../../store/callbackRequest/slice";
import { ERROR_TYPES } from "../../../../../store/constants";
import { mapCheckConnectionResponse } from "../../../../../store/common/utils";
import { CHECK_HOUSE_CONNECTION_STATUS } from "../../../../../store/common/constants";
import { fetchLowSpeedTariffs } from "../../../../../services/fetchLowSpeedTariffs";
import { getIsHighSpeedTariff, getSelectedAddress, selectTargetTariffGroup } from "../selectors";
export var checkConnectionAndTariffsInPopup = createAsyncThunk('checkConnectionAndTariffsInPopup', /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_, _ref) {
    var dispatch, getState, rejectWithValue, state, address, isHighSpeedTariff, house_fias_id, settlement_fias_id, flat, city_fias_id, result, _ref3, redirectInfo, highSpeedAvailable, connectionState, houseInacId, connectionStatus, currentPath, newUrl, tariffData, targetTariffGroup, _yield$fetchLowSpeedT, isSucceeded, tariff;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          dispatch = _ref.dispatch, getState = _ref.getState, rejectWithValue = _ref.rejectWithValue;
          _context.prev = 1;
          state = getState();
          address = getSelectedAddress(state);
          isHighSpeedTariff = getIsHighSpeedTariff(state);
          dispatch(setIsCtnError(false));
          if (!(!address || !address.flat)) {
            _context.next = 8;
            break;
          }
          throw new Error(ERROR_TYPES.emptyAddress);
        case 8:
          house_fias_id = address.house_fias_id, settlement_fias_id = address.settlement_fias_id, flat = address.flat, city_fias_id = address.city_fias_id;
          _context.next = 11;
          return checkHouseConnection({
            houseFiasId: house_fias_id,
            settlementFiasId: settlement_fias_id,
            flat: flat,
            cityFiasId: city_fias_id
          });
        case 11:
          result = _context.sent;
          _ref3 = result || {}, redirectInfo = _ref3.redirectInfo, highSpeedAvailable = _ref3.highSpeedAvailable, connectionState = _ref3.connectionState, houseInacId = _ref3.houseInacId;
          connectionStatus = mapCheckConnectionResponse({
            status: connectionState,
            isHighSpeed: highSpeedAvailable,
            isHighSpeedTariff: isHighSpeedTariff
          });
          if (redirectInfo !== null && redirectInfo !== void 0 && redirectInfo.isNeedRedirect && redirectInfo !== null && redirectInfo !== void 0 && redirectInfo.redirectUrl) {
            currentPath = window.location.pathname;
            newUrl = "".concat(redirectInfo.redirectUrl).concat(currentPath);
            window.location.replace(newUrl);
          }
          if (!(connectionStatus === CHECK_HOUSE_CONNECTION_STATUS.SpeedLimit)) {
            _context.next = 25;
            break;
          }
          targetTariffGroup = selectTargetTariffGroup(state);
          _context.next = 19;
          return fetchLowSpeedTariffs(targetTariffGroup);
        case 19:
          _yield$fetchLowSpeedT = _context.sent;
          isSucceeded = _yield$fetchLowSpeedT.isSucceeded;
          tariff = _yield$fetchLowSpeedT.view;
          if (!(!isSucceeded || !isPlainObject(tariff))) {
            _context.next = 24;
            break;
          }
          throw new Error(ERROR_TYPES.noAlternativeTariff);
        case 24:
          tariffData = tariff;
        case 25:
          return _context.abrupt("return", {
            isRedirect: redirectInfo === null || redirectInfo === void 0 ? void 0 : redirectInfo.isNeedRedirect,
            connectionStatus: connectionStatus,
            tariff: tariffData,
            houseInacId: houseInacId
          });
        case 28:
          _context.prev = 28;
          _context.t0 = _context["catch"](1);
          if (!(_context.t0 instanceof Error)) {
            _context.next = 32;
            break;
          }
          return _context.abrupt("return", rejectWithValue(_context.t0.message));
        case 32:
          throw new Error();
        case 33:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 28]]);
  }));
  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());